import { messageTime } from '../lib/message-time';
import '../message-time.css';

/**
 * #651: one Main Command message's time, from its record's own created_at.
 *
 * Compact local label on screen; the full local date and time on hover and for
 * screen readers; the stored instant in <time dateTime>. A record without a
 * time renders nothing - an unknown time is never shown as a guessed one.
 */
export function MessageTimestamp({ sentAt, nowMs }: {
  readonly sentAt: string | null | undefined;
  readonly nowMs?: number;
}) {
  const time = messageTime(sentAt, nowMs ?? Date.now());
  if (time === null) return null;
  return (
    <time className="message-time" dateTime={time.iso} title={time.full} data-testid="message-time">
      <span aria-hidden="true">{time.label}</span>
      <span className="message-time-full">{time.full}</span>
    </time>
  );
}
